// src/components/Footer.js
import React from "react";
import { Box, Typography, Link } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "primary.main",
        color: "white",
        p: 2,
        mt: "auto",
        textAlign: "center",
      }}
    >
      <Typography variant="body2">
        &copy; {new Date().getFullYear()} Vehicle Rental Platform. All rights
        reserved.
      </Typography>
      {/* <Typography variant="body2">
        Developed by{" "}
        <Link href="https://yourcompany.com" color="inherit" underline="hover">
          Your Company
        </Link>
      </Typography> */}
    </Box>
  );
};

export default Footer;
